const BASE_URL = process.env.REACT_APP_API_SERVER;

export default BASE_URL;

